<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_3"></a><span class="bold">BRITISH NAVAL TRAWLERS AND DRIFTERS</span></h1>
<h1 class="title0"><span class="bold">IN TWO WORLD WARS</span></h1>
<p class="title01"><span class="bold">FROM THE JOHN LAMBERT COLLECTION</span></p>
<div class="img_containert">
<img alt="Image" src="images/p003_01.jpg"/>
</div>
<p class="title01"><span class="bold">Edited and introduced by</span></p>
<p class="title01e"><span class="bold">STEVE R DUNN</span></p>
<div class="img_containert">
<img alt="Image" src="images/p003_02.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?0877e28e